import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  AddExperience,
  UpdateExperience,
  GetExperienceById,
  DeleteExperience,
} from '../services/ExperienceService';

export const ExperienceSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addExperience: '',
    ExperienceList: [],
    getExperience: '',
    updateExperience: '',
  },
  reducers: {
    addExperience: (state, action) => {
      state.addExperience = [action.payload];
    },
    ExperienceList: (state, action) => {
      state.ExperienceList = [action.payload];
    },
    getExperience: (state, action) => {
      state.getExperience = [action.payload];
    },
    updateExperience: (state, action) => {
      state.updateExperience = [action.payload];
    },
  },
});

export const InsertExperience = (payload) => async () => {
  return AddExperience(payload);
};

export const updateExperienceList = (payload, expid) => async () => {
  return UpdateExperience(payload, expid);
};

export const getExperienceByuserId = () => async (dispatch) => {
  GetExperienceById().then((response) => {
    dispatch(getExperience(response.data));
  });
};

export const deleteExperience = (data) => async (dispatch) => {
  DeleteExperience(data)
    .then((response) => {
      Notification('success', response?.data?.message);
      dispatch(getExperienceByuserId());
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const {
  ExperienceList,
  addExperience,
  updateExperience,
  getExperience,
} = ExperienceSlice.actions;
export default ExperienceSlice.reducer;
